import { render, staticRenderFns } from "./activity_browse_page.vue?vue&type=template&id=0db4f492&scoped=true"
import script from "./activity_browse_page.vue?vue&type=script&lang=js"
export * from "./activity_browse_page.vue?vue&type=script&lang=js"
import style0 from "./activity_browse_page.vue?vue&type=style&index=0&id=0db4f492&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db4f492",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0db4f492')) {
      api.createRecord('0db4f492', component.options)
    } else {
      api.reload('0db4f492', component.options)
    }
    module.hot.accept("./activity_browse_page.vue?vue&type=template&id=0db4f492&scoped=true", function () {
      api.rerender('0db4f492', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/group_buy/activity_browse_page.vue"
export default component.exports